@if (showError) {
  <span class="form-error">*{{ errorMessage }}</span>
}

<div class="date-input-control">
  <label class="form-input-label">{{ label() || control.control['label'] }}<ng-content select="[label]" /></label>
  <div class="date-input-wrapper" [class.is-invalid]="showError">
    <input
      class="date-input"
      [formControl]="date"
      [placeholder]="placeholder()"
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="picker"
      (dateChange)="datepickerDateChange($event)"
      [readonly]="true"
      (click)="openDatePicker(picker)"
      [class.isDisabled]="disabled()"
      #input
    />
    @if (date.value && !disabled()) {
      <button class="clear-btn" (click)="clear($event)">
        <app-icon name="cross" width="16px" height="16px" />
      </button>
    }
    <button class="calendar-btn" [class.isDisabled]="disabled()" (click)="picker.open()">
      <app-icon name="calendar" width="16px" height="16px" />
    </button>
  </div>
</div>

<mat-datepicker #picker />
